import { takeEvery, put } from 'redux-saga/effects';
import { API, STATUS } from '@vezeeta/web-utils';
import  CoustomUrls  from 'configs/urls'
import { SUBSCRIPTION } from '../actions/subscription';

function* getCategories() {
  try {
    const apiObj = new API();
    const res = yield apiObj.get(`${CoustomUrls.subscription.getCategories}`, undefined, true);
    if (STATUS.isSuccess(res.status)) {
      yield put({ type: SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES_DONE, categories: res.data });
    } else {
      yield put({ type: SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES_FAIL });
    }
  } catch (err) {
    yield put({ type:SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES_FAIL  });
  }
}
const productsResponseMapper = (res) => {
  const mappedRes = { ...res };
  const products =  mappedRes.data || [];

  mappedRes.data = products.map((product) => ({
    ...product,
    productPlans: (product.productPlans || []).filter((plan) => plan.isActive),
  }));

  return mappedRes;
};

function* getProducts({payload}) {
  try {
    const apiObj = new API();
    let rowRes = yield apiObj.get(`${CoustomUrls.subscription.getProducts}?CategoryKey=${payload.categoryId}&withAllPlans=true&countryId=${payload.countryId}`, undefined, true);
    const res = productsResponseMapper(rowRes)
    if (STATUS.isSuccess(res.status)) {
      yield put({ type: SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS_DONE, products: res.data });
    } else {
      yield put({ type: SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS_FAIL });
    }
  } catch (err) {
    yield put({ type:SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS_FAIL  });
  }
}



export default function* subscription() {
  yield takeEvery(SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES, getCategories);
  yield takeEvery(SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS, getProducts);
}
